<template>
	<div id="center">
		<div class="title_bg">
		<p>数据支撑系统</p>
		</div>
		<!-- 轮播区域 -->
		<div class="carousel-container">
			<transition :name="transitionName">
				<div class="up" v-show="currentIndex === 0" :key="0">
				<!-- 第一组内容 -->
				<div class="bg-ls item items" v-for="item in titleItem" :key="item.title"> 
				<div class="divsj">
				<img src="../assets/sj_icon.png"/> 
				<p class="name">{{ item.title  }}</p>
				</div>
				</div>
				<div class="bg-ls item items" v-for="item in titleItems" :key="item.title"> 
				<div class="divsj">
				<img src="../assets/sj_icon.png"/> 
				<p class="name">{{ item.title  }}</p>
				</div>
				</div>
				</div>
			</transition>
		<transition :name="transitionName">
	<div class="up" v-show="currentIndex === 1" :key="1">
			<!-- 第二组内容 -->
			<div class="bg-ls item" v-for="item in titleItem3" :key="item.title"> 
			<div class="divsj">
				<img src="../assets/sj_icon.png"/> 
				<p class="name">{{ item.title  }}</p>
			</div>
			</div>
			<div class="bg-ls item" v-for="item in titleItem4" :key="item.title"> 
				<div class="divsj">
				<img src="../assets/sj_icon.png"/> 
				<p class="name">{{ item.title  }}</p>
				</div>
			</div>
			</div>
			</transition>
			</div>
	</div>
</template>

<script>
export default {
  data() {
    return {
      titleItem: [
        {
          title: 'COG游戏发行中枢平台',
          number: {
            number: [5900],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '四川游戏动漫版权服务平台',
          number: {
            number: [1280],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '四川游戏研发出版运营综合服务平台',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '四川省大数据中心',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '知信链',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
      ],
      titleItems: [
        {
          title: '成都农商银行资金平台',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '中国银行资金平台',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '天津银行资金平台',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '新网银行资金平台',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        },
        {
          title: '天府信用通',
          number: {
            number: [15],
            textAlign: 'left',
            content: '{nt}',
            style: {
              fontSize: 26
            }
          }
        }
      ],
		titleItem3: [
		{
		title: '浙江民泰商业银行',
		number: {
		number: [15],
		textAlign: 'left',
		content: '{nt}',
		style: {
		fontSize: 26
		}
		}
		},
		
		{
		title: '兴业银行',
		number: {
		number: [15],
		textAlign: 'left',
		content: '{nt}',
		style: {
		fontSize: 26
		}
		}
		},
		{
		title: '中国民生银行',
		number: {
		number: [15],
		textAlign: 'left',
		content: '{nt}',
		style: {
		fontSize: 26
		}
		}
		},
		
		],
		titleItem4: [
		
		{
		title: '交通银行',
		number: {
		number: [15],
		textAlign: 'left',
		content: '{nt}',
		style: {
		fontSize: 26
		}
		}
		},
		{
		title: '中信银行',
		number: {
		number: [15],
		textAlign: 'left',
		content: '{nt}',
		style: {
		fontSize: 26
		}
		}
		},
		{
		title: '中国建设银行',
		number: {
		number: [15],
		textAlign: 'left',
		content: '{nt}',
		style: {
		fontSize: 26
		}
		}
		}
		],
		currentIndex: 0,
		timer: null,
		transitionName: 'slide-left', // 默认切换方向 
		autoPlayInterval: 3000 // 3秒切换一次，1秒可能太快 
    }
  },
  mounted() {
    this.startCarousel();
  },
  beforeDestroy() {
    this.stopCarousel();
  },
  methods: {
		startCarousel() {
		this.stopCarousel(); 
		this.timer  = setInterval(() => {
		this.next(); 
		}, this.autoPlayInterval); 
		},
		stopCarousel() {
		if (this.timer)  {
		clearInterval(this.timer); 
		this.timer  = null;
		}
		},
    next() {
      this.currentIndex = (this.currentIndex + 1) % 2;
    },
    prev() {
      this.currentIndex = (this.currentIndex - 1 + 2) % 2;
    }
  }
}
</script>

<style lang="scss" scoped>
#center {
  display: flex;
  flex-direction: column;
  .title_bg{
    width: 349px;
    height: 40px;
    background-image: url("../assets/c_title.png");
    background-size: cover;
    background-position: center center;
    line-height: 40px;
    margin-bottom: 16px;
    p{
      margin-left: 32px;
      font-size: 19px;
      background-image: linear-gradient(to bottom, #ffffff, #91dbfd);
      -webkit-background-clip: text;
      color: transparent;
      font-weight: bold;
    }
  }
  .up {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    height: 157px;
    background-image: url("../assets/sj_bg.png");
    background-size: cover;
    background-position: center center;
    .divsj{
      width: 145px;
      height: 42px;
      display: flex;
      align-items: center;
    }
    .divsjs{
      width: 108px;
      height: 42px;
      display: flex;
      align-items: center;
    }
    .item {
      width: 20%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      flex-wrap: wrap;
      align-items: center;
      .name{
        color: #c0e5fe;
        font-size: 14px;
        margin-left: 12px;
      }
      .num {
        width: 150px;
        height: 30px;
        margin-top: 20px;
        margin-left: 96px;
      }
    }
    .items:nth-of-type(2){
      width: 22% !important;
    }
    .items:nth-of-type(3){
      width: 22% !important;
    }
    .items:nth-of-type(4){
      width: 22% !important;
    }
    .items:nth-of-type(5){
      width: 14% !important;
    }
    .items:nth-of-type(9){
      width: 20% !important;
    }
    .items:nth-of-type(6){
      width: 20% !important;
    }
    .items:nth-of-type(7){
      width: 20% !important;
    }
    .items:nth-of-type(8){
      width: 20% !important;
    }
    .items:nth-of-type(3) .divsj{
      width: 160px !important;
    }
    // .item:nth-of-type(6) .divsj{
    // 	width: 108px !important;
    // }
    .items:nth-of-type(7) .divsj{
      width: 108px !important;
    }
    .items:nth-of-type(8) .divsj{
      width: 108px !important;
    }
    .items:nth-of-type(9) .divsj{
      width: 108px !important;
    }
    .num3{
      width: 150px;
      height: 30px;
      margin-top: 20px;
      margin-left: 124px;
    }
  }
  .carousel-controls {
    display: flex;
    justify-content: center;
    margin-top: 10px;
    button {
      background: #1a3a5d;
      color: #c0e5fe;
      border: none;
      border-radius: 50%;
      width: 32px;
      height: 32px;
      font-size: 20px;
      margin: 0 8px;
      cursor: pointer;
      transition: background 0.2s;
      &:hover {
        background: #2b5c8c;
      }
    }
  }
  .down {
    padding: 6px 4px;
    padding-bottom: 0;
    width: 100%;
    display: flex;
    height: 255px;
    justify-content: space-between;
    .ranking {
      padding: 10px;
      width: 59%;
      .dv-scr-rank-board {
        height: 225px;
      }
    }
    .percent {
      width: 40%;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 50%;
        height: 120px;
        span {
          margin-top: 8px;
          font-size: 14px;
          display: flex;
          justify-content: center;
        }
      }
      .water {
        width: 100%;
        .dv-wa-le-po {
          height: 120px;
        }
      }
    }
  }
}

	/* 新增轮播动画样式 */
	.carousel-container {
	position: relative;
	height: 157px; /* 与.up高度一致 */
	overflow: hidden;
	}

	.up {
	position: absolute;
	width: 100%;
	top: 0;
	left: 0;
	/* 其他原有样式保持不变 */
	}

	/* 向左滑动动画 */
	.slide-left-enter-active,
	.slide-left-leave-active,
	.slide-right-enter-active,
	.slide-right-leave-active {
	transition: all 0.5s ease;
	}

	.slide-left-enter {
	transform: translateX(100%);
	}
	.slide-left-leave-to {
	transform: translateX(-100%);
	}

	.slide-right-enter {
	transform: translateX(-100%);
	}
	.slide-right-leave-to {
	transform: translateX(100%);
	}
</style>
